import { parseAsString, useQueryState } from 'nuqs';
import React from 'react';
import PayoutDetailsDrawer from './PayoutDetailsDrawer';

const GlobalPayoutDrawer: React.FC = () => {
  const [payoutId, setPayoutId] = useQueryState('payout', parseAsString);

  const handleClose = () => {
    setPayoutId(null);
  };

  if (!payoutId) {
    return null;
  }

  return <PayoutDetailsDrawer payoutId={payoutId} onClose={handleClose} />;
};

export default GlobalPayoutDrawer;
